import { useState } from "react"
import Button from "../../../components/Button"
import colors from "../../../styles/colors"
import { typography } from "../../../styles/typography"
import DropDown from "../../../icons/DropDown"
import DropUp from "../../../icons/DropUp"
import Footer from "../../../components/Footer"


const FAQ = () => {
    const [categories, setCategories] = useState([
        { label: "계정 정보", id: 0 },
        { label: "결제 정보", id: 1 },
        { label: "기기 연결", id: 2 },
        { label: "기기 연결", id: 3 }
    ])
    const [category, setCategory] = useState(0)
    const [faqs, setFaqs] = useState([
        {
            q: "비밀번호를 변경하고 싶어요.",
            a: "기기 측면의 버튼을 2초 이상 눌러 전원을 켜주세요. 전원이 켜지면 연결음이 들리고, 작은 불빛이 함께 표시돼요.",
            category: 0
        },
        {
            q: "블루투스 연결이 잘 안돼요.",
            a: "기기 측면의 버튼을 2초 이상 눌러 전원을 켜주세요. 전원이 켜지면 연결음이 들리고, 작은 불빛이 함께 표시돼요.",
            category: 1
        },
        {
            q: "회원탈퇴를 하고 싶어요.",
            a: "기기 측면의 버튼을 2초 이상 눌러 전원을 켜주세요. 전원이 켜지면 연결음이 들리고, 작은 불빛이 함께 표시돼요.",
            category: 2
        }
    ])

    return (
        <div className={"scrollContainer"} style={style.scrollContainer}>
            <div style={style.tags} className="hide-scrollbar">
                {categories.map((value, i) => {
                    return <Button
                        text={value.label}
                        style={value.id == category ? style.tagOn : style.tag}
                        onClick={() => setCategory(value.id)}
                    />
                })}
            </div>

            <div style={style.faqs}>
                {faqs.map((value, i) => {
                    return (<Item item={value} key={i}/>)
                })}

            </div>
            <Footer style={{marginTop: 150}}/>
        </div>
    )
}

const Item = ({ item, index }) => {
    const [collapsed, setCollapsed] = useState(true)
    return <div style={style.itemContainer}>


        <Button
            style={style.item}
            text={item.q}
            onClick={() => setCollapsed(!collapsed)}
        >
            {collapsed ? <DropDown /> : <DropUp />}
        </Button>
        {!collapsed && <p style={style.answer}>{item.a}</p>}
    </div>
}

const style = {
    scrollContainer: {
        alignItems: 'flex-start',
        overflowY: 'scroll',
        padding: '0px 0px'
    },
    tags: {
        overflowX: 'scroll',
        display: 'flex',
        gap: 8,
        marginTop: 24,
        marginBottom: 32,
        padding: '0px 16px 5px',
        flexShrink: 0
    },
    tag: {
        padding: '6px 18px',
        border: `1px solid ${colors.surfaceBorderColorMono}`,
        flexShrink: 0,
        color: colors.mono300
    },
    tagOn: {
        padding: '6px 18px',
        background: colors.primaryColor500,
        flexShrink: 0,
        color: 'white'
    },
    faqs: {
        display: 'flex',
        flexDirection: 'column',
        width: '100%'
    },
    itemContainer: {
        width: '100%',
        borderBottom: `1px solid ${colors.surfaceBorderColor}`,
        padding: '0px 20px'
    },
    item: {
        ...typography.body["15_regular"],
        color: colors.mono0,
        height: 60,
        width: '100%',
        justifyContent: 'space-between',
        
    },
    answer: {
        ...typography.body["14_regular"],
        color: colors.mono300,
        marginBottom: 24
    }

}
export default FAQ